import * as types from "./actionTypes";
import * as listApi from "../../api/listApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadCitiesSuccess(cities) {
  return { type: types.LOAD_CITIES_SUCCESS, cities };
}

export function loadCities() {
  return function (dispatch) {
    dispatch(beginApiCall())
    return listApi
      .getCities()
      .then((cities) => {
        const options = cities.map((city) => ({label:city.city, value:city.city}))
        dispatch(loadCitiesSuccess(options));
      }
    )
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
